import React, { ReactElement } from 'react';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';
import classNames from 'classnames';

import './sub-menu-item.scss';

interface SubMenuItemProps {
    items: MenuInterface[];
    showRightSlot: boolean;
}

const SubMenuItem: React.FC<SubMenuItemProps> = ({ items, showRightSlot }): ReactElement | null => (
    <div className="sub-menu__item-container">
        <div className="row">
            {items.map(subItem => (
                <div
                    key={subItem.url}
                    className={classNames('sub-menu-item col', {
                        'col-4': showRightSlot,
                        'col-md-6': showRightSlot,
                        'col-3': !showRightSlot,
                        'col-md-4': !showRightSlot
                    })}
                >
                    <div className="sub-menu-item__header" data-section="menu-level-2">
                        {subItem[MenuKeys.image] && (
                            <div className="image">
                                <img src={subItem[MenuKeys.image] || ''} alt={subItem[MenuKeys.name]} />
                            </div>
                        )}
                        <a href={subItem.url} className="name">
                            {subItem[MenuKeys.name]}
                        </a>
                    </div>
                    {Boolean(subItem[MenuKeys.items]?.length) && (
                        <ul className="sub-menu-item__cat-list" data-section="menu-level-3">
                            {subItem[MenuKeys.items]?.map(catItem => (
                                <li key={catItem.url} className="sub-menu-item__cat-list__item">
                                    <a href={catItem.url} title={catItem[MenuKeys.name]}>
                                        {catItem[MenuKeys.name]}
                                    </a>
                                </li>
                            ))}
                            <li className="sub-menu-item__cat-list__item">
                                <a href={subItem.url} className="more">
                                    Zobacz pozostałe
                                </a>
                            </li>
                        </ul>
                    )}
                </div>
            ))}
        </div>
    </div>
);

export default SubMenuItem;
